let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("csrC6")).then(() => parcelRequire('95hjm'));